import API from "../api/api";
import { filterActiveResponseData } from "./activeDataUtils";

export const getSocialMedia = async () => {
    try {
        const response = await API.post("/socialMediaSection/list", {
            sEcho: 1,
            iDisplayStart: 0,
            iDisplayLength: 10,
            sSearch: "",
            iSortCol_0: 0,
            sSortDir_0: "asc",
            aaSorting: [[0, "asc"]],
            bRegex: false,
            bRegex_0: false,
            bSearchable_0: true,
            bSortable_0: true,
            mDataProp_0: 0
        });
        return filterActiveResponseData(response.data);
    } catch (error) {
        console.error("Error fetching social media data:", error);
        throw error;
    }
};
